<template>
    <form>
        <div class="bet-name">
            <span>{{'future_bet' | translate }}</span>
        </div>
        <div class="future-bet">
            <input  id="future"
                v-model="betting.numEvents"
                v-future-bet-validator
                type="number"
                @keydown="checkChars"
                @keydown.enter.prevent="setFocus()"
                @keydown.tab.prevent="setFocus()"
                autocomplete="off"
                :disabled="isBettingDisabled"
            >
        </div>
    </form>
</template>

<script>

    /**
     * Future bet component.
     * @module components/shop/future bet
     * @method  setFocus
     */

    import {BettingSvc} from '../../../services/betting.service';
    import {EventBus}   from '../../../utilities/event.bus';
    import {FutureBetValidator} from '../../../directives/futurebet_validator';
    import {invalidChars} from '../../../utilities/invalidCharsChecker';
    import {GameSvc} from '../../../services/game.service';
    import {translate} from '../../../filters/translate';

    let futureBet;


    export default {
        directives: {
            FutureBetValidator,
        },
        filters: {
            translate,
        },
        data() {
            return {
                betting : BettingSvc.getBettingSvc(),
                future_bet : 'future_bet'
            }
        },
        computed: {
            isBettingDisabled () {
                return GameSvc.getGameSvc().gameInfo.betsBlocked;
            }
        },

        mounted(){
            futureBet =  document.getElementById('future');

            setTimeout(() => {
              futureBet.focus();
              futureBet.select();
            }, 0);
        },

        methods: {
            checkChars(event) {
                invalidChars(event)
            },
            /**
             * Set input focus
             */

            setFocus(e){
                if(futureBet.value){
                    // ready for creating bet
                    EventBus.$emit('Keno.FutureBetValid');
                    return;
                }

                futureBet.select();
            }
        }
    };
</script>
<style  lang="scss">
    @import '../../../assets/style/shop/betting';
</style>



// WEBPACK FOOTER //
// FutureBet.vue?2f6cfd57